import { gql } from '@apollo/client';
import * as React from 'react';
import { useHotToast } from 'src/utils/useHotToast';
import {
  EditCarModal_carFragment,
  UpdateCarMutation,
  useUpdateCarMutation,
} from './__generated__/EditCarDetailsForm.generated';
import { UpdateCarInput } from 'src/graphql/__generated__/globalTypes';
import { CarView } from '../FrontDeskPage/CarView';

export interface IEditCarDetailsFormProps {
  car: EditCarModal_carFragment;
  onCarSaved: (newCar: UpdateCarMutation['updateCar']) => void;
}

export const EditCarDetailsForm: React.FunctionComponent<
  IEditCarDetailsFormProps
> = ({ car, onCarSaved }) => {
  const { saveCar, isSavingCar } = useSaveCar(
    (newCar: UpdateCarMutation['updateCar']) => {
      onCarSaved(newCar);
    }
  );
  return (
    <CarView
      car={car}
      isSavingCar={isSavingCar}
      onSaveCar={carInput => {
        saveCar(carInput);
      }}
      key={car.id + (car.vin || '')}
    />
  );
};

const fragment = gql`
  fragment EditCarModal_car on Car {
    createdAt
    id
    year
    make
    model
    colour
    vin
    licensePlate
    trim
  }
`;

function useSaveCar(
  onCarSaved: (newCar: UpdateCarMutation['updateCar']) => void
) {
  const toast = useHotToast();
  const [setCar, { loading: isSavingCar, data }] = useUpdateCarMutation({
    fetchPolicy: 'no-cache',
    onError: e => {
      toast.error(e.message);
    },
    onCompleted: car => {
      onCarSaved(car.updateCar);
    },
  });
  return {
    saveCar: (car: UpdateCarInput) => {
      setCar({
        variables: {
          car: {
            id: car.id,
            make: car.make,
            model: car.model,
            year: car.year,
            colour: car.colour,
            vin: car.vin,
            licensePlate: car.licensePlate,
            trim: car.trim,
          },
        },
      });
    },
    isSavingCar,
    car: data?.updateCar,
  };
}

const SET_CAR = gql`
  mutation UpdateCar($car: UpdateCarInput!) {
    updateCar(car: $car) {
      createdAt
      id
      make
      model
      year
      colour
      vin
      licensePlate
      trim
    }
  }
`;
